<template>
  <div style="top:0px">
    <p class="time shadow" v-text="currentTime" style="margin: 0px"></p>
  </div>
</template>
<script>
  import moment from 'moment'
  export default{
    data() {
      return {
        message: 'Current Time:',
        currentTime: null
      }
    },
    methods: {
      updateCurrentTime() {
        this.currentTime = moment().format('LTS');
      }
    },
    created() {
      this.currentTime = moment().format('LTS');
      setInterval(() => this.updateCurrentTime(), 1 * 1000);
    }
  }
</script>

<style scoped>
  .time {
    font-size: 15pt;
  }

  .shadow {
    text-shadow: 0 0 15px rgba(100, 100, 100, .35);
  }

</style>
